/**
 * carousel.js — nút trước/sau và chấm vị trí cho dải sản phẩm cuộn ngang (mục 22).
 *
 * Trượt bằng cuộn ngang + scroll-snap (CSS) nên vuốt cảm ứng và trackpad chạy sẵn của
 * trình duyệt; script chỉ gọi scrollBy và theo dõi vị trí cuộn. Mỗi lần bấm trượt đúng
 * một "trang" = số card nhìn thấy, nên đổi bề rộng card trong CSS không phải sửa JS.
 *
 * Markup: [data-carousel] chứa [data-carousel-track] (khung cuộn),
 *         [data-carousel-prev] / [data-carousel-next] và [data-carousel-dots] (để trống).
 * Đặt được trong [role=tabpanel] (js/tabs.js): mở tab là đo lại.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    [].slice.call(document.querySelectorAll('[data-carousel]')).forEach(function (root) {
        var track = root.querySelector('[data-carousel-track]');
        var prev = root.querySelector('[data-carousel-prev]');
        var next = root.querySelector('[data-carousel-next]');
        var dots = root.querySelector('[data-carousel-dots]');
        if (!track) return;

        function step() {
            var first = track.firstElementChild;
            if (!first) return track.clientWidth;
            var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
            var card = first.getBoundingClientRect().width + gap;
            return Math.max(card, Math.floor((track.clientWidth + gap) / card) * card);
        }

        function pages() {
            var max = track.scrollWidth - track.clientWidth;
            return max <= 2 ? 1 : Math.ceil(max / step() - 0.05) + 1;
        }

        function current() {
            var max = track.scrollWidth - track.clientWidth;
            if (track.scrollLeft >= max - 2) return pages() - 1;
            return Math.round(track.scrollLeft / step());
        }

        function renderDots() {
            if (!dots) return;
            var total = pages();
            dots.innerHTML = '';
            if (total < 2) return;
            for (var i = 0; i < total; i++) {
                var dot = document.createElement('button');
                dot.type = 'button';
                dot.setAttribute('aria-label', 'Trang ' + (i + 1) + ' / ' + total);
                dot.setAttribute('data-index', i);
                dots.appendChild(dot);
            }
            update();
        }

        function update() {
            var max = track.scrollWidth - track.clientWidth;
            if (prev) prev.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft >= max - 2;
            var index = current();
            if (dots) {
                [].slice.call(dots.children).forEach(function (dot, i) {
                    dot.setAttribute('aria-current', i === index ? 'true' : 'false');
                });
            }
        }

        if (prev) {
            prev.addEventListener('click', function () {
                track.scrollBy({ left: -step(), behavior: 'smooth' });
            });
        }

        if (next) {
            next.addEventListener('click', function () {
                track.scrollBy({ left: step(), behavior: 'smooth' });
            });
        }

        if (dots) {
            dots.addEventListener('click', function (event) {
                var dot = event.target.closest('button[data-index]');
                if (!dot) return;
                track.scrollTo({ left: Number(dot.getAttribute('data-index')) * step(), behavior: 'smooth' });
            });
        }

        var ticking = false;
        track.addEventListener(
            'scroll',
            function () {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(function () {
                    update();
                    ticking = false;
                });
            },
            { passive: true }
        );

        var resizeTimer;
        window.addEventListener('resize', function () {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(renderDots, 150);
        });

        // Carousel nằm trong tab panel đang ẩn (trang chủ: tab loại vang) đo ra bề rộng 0 lúc tải
        // trang → không có chấm, nút sau bị tắt. tabs.js bắn tabs:change sau khi mở panel: đo lại.
        document.addEventListener('tabs:change', function () {
            if (!root.offsetParent) return;
            renderDots();
            update();
        });

        renderDots();
        update();
    });
})();
